import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import ProductSearchResult from './productSearchResult';

import {
	saveProductLineFilters,
	resetProductNumberKeywordResultList,
	saveNarrowYourResultSelectedValue,
} from '../../../redux/actions';

class PreLoginSearchResult extends Component {

    constructor(props){
        super(props);
        this.state = {
            errorMessage: "",
            typeOfSearch: "",

			selectedNarrowYourResult: "",
			hideNarrowByFilters: true
        }
        this.fetchProductLineSearchResult = this.fetchProductLineSearchResult.bind(this);
    }

    componentDidMount() {
        var self = this;
		const { state } = self.props;
		if(state.product.zipCode === "" || state.product.accountNumber === "") {
			browserHistory.push('/login');
		} else {
	        self.setState({
				selectedNarrowYourResult: self.props.state.product.productLine.navigationState,
	            typeOfSearch: self.props.params.typeOfSearch
	        });
			if(self.props.params.typeOfSearch === 'product-line') {
				self.props.fireGTMTag('Prelogin Product Line', {
					navElementText: _.unescape(self.props.state.product.productLine.label),
					navURL: '/prelogin/search-result/product-line'
				});
			}
		}
    }

    fetchProductLineSearchResult(navigationState, typeOfSearch) {
        const self = this;
        const { state } = self.props;
		self.props.checkAndSetSearchResult(
			"product-line",
			state.product.accountNumber,
			state.product.zipCode,
			"",
			navigationState,
			() => {
				if(self.state.narrowFilterChanged) {
					self.setState({
						narrowFilterChanged: false,
					});
				}
				self.props.fireGTMTag('Prelogin Search Result Filter', {
					filterCategory: self.props.state.product.productLine.label,
					filterTerm: self.state.selectedNarrowYourResultLabel,
					filterResults: self.props.state.product.productNumberKeywordResult.length
				});
			}
		);
    }

    handleNarrowYourResults(event) {
		const self = this;
		const label = event.target.options[event.target.selectedIndex].innerText,
			value = event.target.value;
		this.setState({
			hideNarrowByFilters: value === this.props.state.product.productLine.navigationState,
			selectedNarrowYourResult: value,
			selectedNarrowYourResultLabel: label,
			narrowFilterChanged: true
		}, () => {
			self.props.saveNarrowYourResultSelectedValue({
				value,
				label
			});
	        self.fetchProductLineSearchResult(value, self.state.typeOfSearch);
		});
    }

    handleFilterCheck(displayName, filterName, navigationState, event) {
		let { product } = this.props.state;
		if(product && product.productLineFilters) {
			var original = product.productLineFilters;
			original.filters.map((item, index) => {
				if(item.displayName === displayName) {
					item.values.map((itm, ind) => {
						if(itm.value === filterName) {
							itm.checked = event.target.checked;
						}
						return null;
					});
				}
				return null;
			});
			product.productLineFilters = original;
		}
		if(event.target.checked === false)
			navigationState = navigationState.substring(0, navigationState.lastIndexOf('+'))
        this.fetchProductLineSearchResult(navigationState, this.state.typeOfSearch);
    }

    clearAllFilters(event) {
        event.preventDefault();
        var self = this;

		self.setState({
			selectedNarrowYourResult: self.props.state.product.productLine.navigationState,
			hideNarrowByFilters: true
		});

		//Clear filter first time once user comes first on this page after searching from login page
		self.props.saveProductLineFilters(null);
		//Reset List first then new values will be added
		self.props.resetProductNumberKeywordResultList();

        this.fetchProductLineSearchResult(self.props.state.product.productLine.navigationState, this.state.typeOfSearch);
    }

    render() {
        var self = this,
            narrowByFilters = [];
        const { state } = self.props;
        let { productNumberKeywordResult } = state.product;
        if(state.product.productLineFilters && !_.isEmpty(state.product.productLineFilters.filters)) {
			narrowByFilters = state.product.productLineFilters.filters
        }
        return (
            <div>
               	<p><b>{this.state.errorMessage}</b></p>
               	<h1>{this.state.typeOfSearch==='product-number'?"":_.unescape(state.product.productLine.label)}</h1>
               	<h2 className={this.state.typeOfSearch==='product-number'?"":"hide"}><span style={{fontWeight: 'normal'}}>You searched:</span> {state.searchKeyword.postLoginSearchKeyword?state.searchKeyword.postLoginSearchKeyword.replace(/ /g, ', ').toUpperCase():''}</h2>
               	<p>
                	<b>Results shown are for:</b> &nbsp; &nbsp; Account # {state.product.accountNumber?state.product.accountNumber.toUpperCase():''} &nbsp;&nbsp; Zip Code {state.product.zipCode?state.product.zipCode:''}
			 	</p>
			   	{this.state.typeOfSearch==='product-line'
                    ?<div>
                        <h2 className="blue">
                            <span className="withIcon withFilterIcon">Narrow Your Results (optional)</span>
                        </h2>
                        <form className="narrowResultsForm withNoBeforeUnloadBehavior">
							<select name="narrow" onChange={this.handleNarrowYourResults.bind(this)} value={this.state.selectedNarrowYourResult} disabled={!state.product.productLineNarrowYourResultsFilter || (state.product.productLineNarrowYourResultsFilter && state.product.productLineNarrowYourResultsFilter.length === 0)}>
                                <option value={state.product.productLine.navigationState}>All {_.unescape(state.product.productLine.label)}</option>
                                {state.product.productLineNarrowYourResultsFilter && state.product.productLineNarrowYourResultsFilter.map((item, index) => {
                            		return <option key={index} value={"?N=" + item.categoryId}>{item.name}</option>
                                })}
                            </select>
                        </form>
                        <div id="narrowBy" className={"narrowBy "+(this.state.hideNarrowByFilters?"hide":"")}>
                           	<div className="narrowBy_inner1">
                              	<div className="narrowBy_inner2">
                                 	<div className="narrowBy_inner3">
	                                    <div className="narrowBy_inner4">
	                                       	<div className="heading">
	                                          	<h2>Narrow By <span className="unbold">(Optional)</span></h2>
	                                          	<p className="clearAllParagraph"><a href="" onClick={this.clearAllFilters.bind(this)}>Clear All</a></p>
	                                       	</div>
	                                       	<div id="filtersContainer">
	                                            {narrowByFilters.map((item, index) => {
	                                                return <div className="filterBox" key={index}>
	                                                   <div className="filterBox_inner">
	                                                      <div className="filterBox_inner2">
	                                                         <h3 className="filterHeading">{item.displayName}</h3>
	                                                         <div className="checkboxContainer">
	                                                            {item.values.map((itm, ind) => {
	                                                                return <div key={ind} className={"checkboxDiv "+(itm.disable?'disabledCheckboxDiv':'')}>
																		{itm.checked?
																			<input type="checkbox" checked={!itm.checked?false:true} className="checkbox" disabled={!itm.disable?false:true} onChange={self.handleFilterCheck.bind(this, item.displayName, itm.value, itm.dimensionId)} id={"checkbox_"+index+"_"+ind} defaultValue={itm.dimensionId} />
																			:<input type="checkbox" checked={!itm.checked?false:true} className="checkbox" disabled={!itm.disable?false:true} onChange={self.handleFilterCheck.bind(this, item.displayName, itm.value, itm.dimensionId)} id={"checkbox_"+index+"_"+ind} defaultValue={itm.dimensionId} />
																		}
	                                                                   <label htmlFor={"checkbox_"+index+"_"+ind} style={{cursor: 'pointer'}}>{itm.value}</label>
	                                                                </div>
	                                                            })}
	                                                         </div>
	                                                      </div>
	                                                   </div>
	                                                </div>
	                                            })}
	                                          	<div style={{clear: 'both'}}></div>
	                                       	</div>
                                      		<div style={{clear: 'both'}}></div>
	                                    </div>
                                 	</div>
                              	</div>
                           	</div>
                        </div>
                    </div>
                :null}
                <ProductSearchResult
					checkIfFP={this.props.checkIfFP}
					validateFDD={this.props.validateFDD}
					dispatch={self.props.dispatch}
					productNumberKeywordResult={productNumberKeywordResult}
					typeOfSearch={this.state.typeOfSearch}
					formatETADate={this.props.formatETADate}
				/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	saveProductLineFilters: (data) => dispatch(saveProductLineFilters(data)),
	resetProductNumberKeywordResultList: () => dispatch(resetProductNumberKeywordResultList()),
	saveNarrowYourResultSelectedValue: (data) => dispatch(saveNarrowYourResultSelectedValue(data)),
});

PreLoginSearchResult = connect(mapStateToProps, mapDispatchToProps)(PreLoginSearchResult);
export default PreLoginSearchResult;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/SearchResult/index.js